import type { ClientType } from "@/lib/types";

export const CLIENT_TYPE_LABELS: Record<ClientType, string> = {
  RESTAURANTE: "Restaurante",
  SUPERMERCADO: "Supermercado",
  COZINHA_INDUSTRIAL: "Cozinha Industrial",
  CLIENTE_FINAL: "Cliente Final",
};

/** Cliente final é o único tipo pessoa física — os demais são pessoa jurídica. */
export function isPessoaFisica(clientType: ClientType | null | undefined): boolean {
  return clientType === "CLIENTE_FINAL";
}

/**
 * Rótulo do documento da conta. O backend guarda CPF e CNPJ no mesmo campo
 * (`cnpj`); é o tipo de cliente que diz qual dos dois está ali.
 */
export function documentLabel(clientType: ClientType | null | undefined): "CPF" | "CNPJ" {
  return isPessoaFisica(clientType) ? "CPF" : "CNPJ";
}

/** Rótulo do nome principal da conta: razão social (PJ) ou nome completo (PF). */
export function legalNameLabel(clientType: ClientType | null | undefined): string {
  return isPessoaFisica(clientType) ? "Nome completo" : "Razão social";
}
